import { isNotNil, isNil } from '~/utilities/type-guards';
import type { TopLevelComment } from '../Comments/types';

export const flattenCommentEdges = (
  edges: ({ node?: TopLevelComment | null | undefined } | null | undefined)[] | null | undefined,
): TopLevelComment[] => {
  if (isNil(edges)) {
    return [];
  }

  return edges.map((edge) => edge?.node).filter((node): node is TopLevelComment => isNotNil(node));
};
